import React from "react";
import InfoBanner from '../InfoBanner'

/**
 * Componente para mostrar la new Planeación Líquida (Contenido estático).
 *
 * @component
 *
 */

export const PlaneacionLiquida = (props) => {
  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 620;

  React.useEffect(() => {
    /* Inside of a "useEffect" hook add an event listener that updates
        the "width" state variable when the window size changes */
    window.addEventListener("resize", () => setWidth(window.innerWidth));

    /* passing an empty array as the dependencies of the effect will cause this
        effect to only run when the component mounts, and not each time it updates.
        We only want the listener to be added once */
  }, []);

  const url = window.location.href;

  return (
    <section id="news-detail" className="text-center">
      <div className="col-md-8 col-md-offset-2 section-title">
        <h2>
          <span className="title">News</span>
        </h2>
      </div>
      <InfoBanner
        section={'Planeación Líquida'}
        tittle={'Planeación <br/> Líquida'}
        readingTime={'Tiempo de lectura 4 minutos'}
        keywords={['Planning', 'Estrategia']}
        urlDesktop={'/img/news/PlaneacionLiquida/PlaneacionLiquida_img1.webp'}
        urlMobile={'/img/news/PlaneacionLiquida/PlaneacionLiquida_img1_mob.webp'}
      />
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12 visible-md visible-lg">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-1">&nbsp;</div>
          </div>
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                  ¿Cómo abordar y lograr fluir en este mundo de constante cambio? ¿Cómo podemos llevar a cabo una planeación estratégica efectiva y plan de acción sólido en el ámbito del marketing digital?
                </b>{" "}
                Lo primero es reconocer que el cambio es inevitable, pero eso no significa que las marcas deban dejar de lado su planeación estratégica, al contrario, implica abrazar un mindset ágil y de adaptabilidad constante.
                <br></br>
                <br></br>
                Imaginemos la estrategia digital como un río que fluye con agilidad y dinamismo, adaptándose a los cambios de terreno y desafíos del camino. La filosofía de la planeación líquida abraza esta analogía, permitiendo que las estrategias fluyan y se adapten sin perder la esencia. Esta mentalidad aboga por la agilidad, sobre la rigidez, por el análisis constante sobre la complacencia, y por la experimentación continua sobre la conformidad.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Desbloqueando Potencial"
                  className="img-responsive"
                  src="/img/news/PlaneacionLiquida/PlaneacionLiquida_img2.webp"
                ></img>
                <h2 className="img3Text">Con estrategias dinámicas y efectivas se mejora la experiencia del usuario y se resuelvan puntos de fricción.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                Antes, las campañas publicitarias se diseñaban con semanas o meses de antelación. Hoy, en un panorama donde las tendencias pueden cambiar de la noche a la mañana, la adaptabilidad es la clave del éxito. Las plataformas digitales, con su capacidad de proporcionar datos en tiempo real, se convierten en el lienzo donde los especialistas en marketing digital en conjunto con las marcas pueden trazar una estrategia digital líquida. Esta estrategia impulsa la agilidad de decisión basada en datos. Es así que, los datos y análisis se vuelven compañeros inseparables que permiten a las marcas discernir entre tendencias pasajeras y movimientos reales del mercado.
                <br></br>
                <br></br>
                Pero la planeación líquida no solo depende de los datos. La esencia de la marca, sus valores y su conexión emocional con el público, permanecen como pilares inmutables en este flujo constante. La autenticidad es la moneda de cambio en un mundo saturado de mensajes. No se trata solo de buscar crecimiento, sino de comprender la experiencia del usuario, identificar y solucionar los puntos de fricción en la adquisición y retención de clientes, para proporcionar una experiencia excepcional en cada interacción.
                <br></br>
                <br></br>
              </p>
            </div>
          </div>
        </div>
      </article>
      <div
        className={width < breakpoint ? "" : "container-fluid padding-fluid"}
      >
        <div className={width < breakpoint ? "" : "row"}>
          <div className={width < breakpoint ? "" : "col-md-12"}>
            <div className={width < breakpoint ? "" : "col-md-8 col-md-offset-2 text-center"}>
              <div className="imgWithText">
                <img
                  style={{ width: "100%" }}
                  alt="Desbloqueando Potencial"
                  className="img-responsive"
                  src="/img/news/PlaneacionLiquida/PlaneacionLiquida_img3.webp"
                ></img>
                <h2 className="img3Text">Una planeación líquida permite a las marcas ajustar estrategias en tiempo real y adaptarse ágilmente a un entorno en constante cambio.</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
      <article className="container-fluid padding-fluid">
        <div className="row">
          <div className="col-md-12">
            <div className="col-md-8 col-md-offset-2 text-center">
              <p>
                <b>
                  Entonces, ¿cómo se utiliza la planeación líquida para optimizar presupuestos y maximizar el retorno de inversión (ROI)?
                </b>
                <br></br>
                <br></br>
                La respuesta yace en la mentalidad de experimentación continua. Cada acción, cada campaña, es una oportunidad para aprender y evolucionar. A través de pruebas y ajustes, el enfoque líquido permite a las marcas y consultoras como nosotros pivotar estrategias según los resultados en tiempo real. No se trata de predecir el futuro, sino de moldearlo a través de adaptaciones bien informadas.
                <br></br>
                <br></br>
                Para aquellas marcas que se resisten al cambio, que dudan en abrazar la fluidez en sus estrategias, el mensaje es claro: están relegándose a un pasado que ya no existe. La planeación líquida no es un capricho, es una necesidad imperante en un mundo que gira a una velocidad vertiginosa. Adaptarse es crecer, y crecer es transformarse.
              </p>
            </div>
            <div className="col-md-1 text-left"></div>
            <div
              className="col-md-3 text-left"
              style={{ display: width < breakpoint ? "block" : "none" }}
            >
              <p className="titleShare">COMPARTE</p>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.facebook.com/sharer/sharer.php?u=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Facebook
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://twitter.com/intent/tweet?url=${url}&text=Planeación Líquida`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Twitter
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`https://www.linkedin.com/sharing/share-offsite/?url=${url}`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  LinkedIn
                </a>
              </div>
              <div style={{ paddingBottom: "7px" }}>
                <a
                  className="share"
                  href={`mailto:?subject=Quiero compartir contigo esta noticia&body=Mira esta noticia ${url}`}
                >
                  Email
                </a>
              </div>
            </div>
          </div>
        </div>
      </article>
    </section>
  );
};
